<template>
  <v-card>
    <v-toolbar color="blue darken-3" dark flat>
      <v-btn
        v-permission="['kafka-import-dictionary-create']"
        class="primary"
        @click="$dialog.show('import-kafka-dictionary-dialog')"
      >
        Создать
      </v-btn>
    </v-toolbar>
    <v-data-table
      :loading="isLoading"
      hide-default-footer
      :items="dictionaryList"
      :headers="headers"
    >
      <template #item.actions="{ item }">
        <v-btn
          v-permission="['kafka-import-dictionary-edit']"
          x-small
          color="primary"
          dark
          @click="$dialog.show('import-kafka-dictionary-dialog', { item })"
        >
          Редактировать
        </v-btn>
        <v-btn
          v-permission="['kafka-import-dictionary-delete']"
          x-small
          color="red"
          dark
          @click="$dialog.show('remove-event-confirmation', { itemId: item.id })"
        >
          Удалить
        </v-btn>
      </template>
    </v-data-table>
    <dictionary-dialog @submit="submit" />
    <remove-confirmation
      name="remove-event-confirmation"
      title="Вы действительно желаете удалить элемент?"
      @confirmed="onRemove"
    />
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DictionaryDialog from '@/views/system/dictionaries/components/DictionaryDialog.vue';
import RemoveConfirmation from '@/components/dialogs/confirmations/RemoveConfirmation.vue';

export default {
  name: 'import-kafka-dictionary-list',
  asyncData({ store }) {
    return store.dispatch('kafkaImportDictionary/getList');
  },
  components: { DictionaryDialog, RemoveConfirmation },
  data: () => ({
    headers: [
      { value: 'name', text: 'Название', sortable: false },
      {
        value: 'actions',
        text: '',
        sortable: false,
        width: '22.5%',
      },
    ],
    isLoading: false,
  }),
  computed: {
    ...mapState('kafkaImportDictionary', {
      dictionaryList: 'list',
    }),
  },
  methods: {
    ...mapActions('kafkaImportDictionary', {
      createDictionary: 'create',
      updateDictionary: 'update',
      removeDictionary: 'remove',
      getDictionaries: 'getList',
    }),

    async submit({ form, isEdit }) {
      this.isLoading = true;
      if (isEdit) {
        await this.updateDictionary(form);
      } else {
        await this.createDictionary(form);
      }
      await this.getDictionaries();
      this.isLoading = false;
    },

    async onRemove(id) {
      this.isLoading = true;
      await this.removeDictionary(id);
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>

</style>
